var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11V1.5L2 0.5H14L15.5 2V10L12 12H6.5L2.5 15V12L0.5 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8003 0H2.19971C0.986816 0 0 1.07239 0 2.39094V10.1074C0 11.423 0.98252 12.4937 2.19189 12.4984V16L6.82168 12.4984H13.8003C15.0132 12.4984 16 11.4258 16 10.1074V2.39094C16 1.07239 15.0132 0 13.8003 0ZM15.0625 10.1074C15.0625 10.8638 14.4963 11.4794 13.8003 11.4794H6.52754L3.12939 14.0496V11.4794H2.19971C1.50371 11.4794 0.9375 10.8638 0.9375 10.1074V2.39094C0.9375 1.63433 1.50371 1.019 2.19971 1.019H13.8003C14.4963 1.019 15.0625 1.63433 15.0625 2.39094V10.1074Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 4.67015C4.28125 4.38876 4.50936 4.16064 4.79075 4.16064H11.2071C11.4885 4.16064 11.7166 4.38876 11.7166 4.67015C11.7166 4.95153 11.4885 5.17965 11.2071 5.17965H4.79075C4.50936 5.17965 4.28125 4.95153 4.28125 4.67015Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 7.54905C4.28125 7.26766 4.50936 7.03955 4.79075 7.03955H11.2071C11.4885 7.03955 11.7166 7.26766 11.7166 7.54905C11.7166 7.83044 11.4885 8.05855 11.2071 8.05855H4.79075C4.50936 8.05855 4.28125 7.83044 4.28125 7.54905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentActive);
export default __webpack_public_path__ + "static/media/comment_active.320b94a2.svg";
export { ForwardRef as ReactComponent };